<template>
  <InfuseTable
    :columns="columns"
    :rows="rows"
    :loading="loading"
    :search="search"
    :has-more-items="false"
    @click-row="(row: FailedImport) => emit('click-row', row)"
    @load="emit('load')"
    @search="(query: string) => emit('search', query)"
  >
    <template #error="{ data }">
      <div class="italic">{{ data }}</div>
    </template>
  </InfuseTable>
</template>

<script lang="ts" setup>
import { InfuseTable } from '@infuse/ui/components';

import type { UiTableColumn } from '@infuse/ui/domain';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { FailedImport } from '@infuse/e-connector/charging-station/domain';

interface Emits {
  (e: 'click-row', row: FailedImport): void;
  (e: 'load'): void;
  (e: 'search', query: string): void;
}

const emit = defineEmits<Emits>();

interface Props {
  loading?: boolean;
  rows: FailedImport[];
  searchEnabled?: boolean;
  searchQuery?: string;
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  searchEnabled: false,
  searchQuery: ''
});

const { t } = useI18n();

const search = computed(() =>
  !props.searchEnabled
    ? undefined
    : {
        placeholder: t('e_connector.common.table_search_all'),
        query: props.searchQuery
      }
);

const columns: UiTableColumn[] = [
  {
    name: 'name',
    label: () => t('e_connector.common.chargingStation.name'),
    field: 'chargingStation.name',
    bold: true
  },
  {
    name: 'centralSystemName',
    label: () => t('e_connector.common.chargingStationLink.centralSystemName'),
    field: 'chargingStation.centralSystemName'
  },
  {
    name: 'error',
    label: () => t('e_connector.common.import.error'),
    field: 'error'
  }
];
</script>
